export enum JobDefinitionRunningType {
    SCHEDULE = 'SCHEDULE',
    MESSAGE = 'MESSAGE',
}
